import { render, staticRenderFns } from "./TransferTab2.vue?vue&type=template&id=641e0a6a"
import script from "./TransferTab2.vue?vue&type=script&lang=js"
export * from "./TransferTab2.vue?vue&type=script&lang=js"
import style0 from "./TransferTab2.vue?vue&type=style&index=0&id=641e0a6a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports